import React, { useMemo } from "react";
import { MockedAuthManager } from "../../../contexts/AuthManager";
import { buildUser, buildWorkerProfile } from "../../factories";
import { ProfileType } from "../../../__generated__/graphql";
import type { Meta, StoryObj } from "@storybook/react";
import { MockedProvider } from "@apollo/client/testing/react";
import FiscalAttestationEditorScreen from "../../../screens/profile-editor/FiscalAttestationEditor";
import {
    MockedProfileSwitcherManager,
    ProfileIdType,
} from "../../../contexts/ProfileSwitcherManager";
import { createNativeStackNavigator } from "@react-navigation/native-stack";
import { StoryStackNavigatorContainer } from "../../display-helpers";

const Stack = createNativeStackNavigator<{
    FiscalAttestationEdit: { profileId: ProfileIdType };
}>();

const StoryComponent = () => {
    const user = useMemo(() => buildUser({ workerProfile: buildWorkerProfile() }), []);

    return (
        <MockedAuthManager user={user}>
            <MockedProfileSwitcherManager profileType={ProfileType.Worker}>
                <MockedProvider mocks={[]}>
                    <StoryStackNavigatorContainer>
                        <Stack.Navigator initialRouteName="FiscalAttestationEdit">
                            <Stack.Screen
                                name="FiscalAttestationEdit"
                                component={FiscalAttestationEditorScreen}
                            />
                        </Stack.Navigator>
                    </StoryStackNavigatorContainer>
                </MockedProvider>
            </MockedProfileSwitcherManager>
        </MockedAuthManager>
    );
};

const meta = {
    title: "Screens/ProfileEditor/FiscalAttestation",
    component: StoryComponent,
} satisfies Meta<typeof StoryComponent>;

export default meta;

type Story = StoryObj<typeof meta>;

export const Default: Story = {};
